module.exports = __webpack_public_path__ + "files/2e3af968fa0cef8d1167537b2d0e7949.png";